<template>
  <div id="algorithm">
    <div class="bn-wrap">
      <div class="inner">
        <h3 class="tit">추천 시그널 참고지표</h3>
        <p class="sub">MADSCIENTERZ’ 알고리즘</p>
        <p class="exp">
          MADSCIENTERZ’ 알고리즘은 신뢰도 높은 매매기법과 수식 기반의 트레이딩 추천 시그널 참고지표를 제공합니다. 강의와 같은 원리로 <br class="dp-no">만들어져 배포되는 알고리즘을 통해서 타점이 시드를 우상향 시키는 신뢰도를 체크하세요.
        </p>
      </div>
    </div>

    <div class="inner">
      <AlgorithmList/>
    </div>
  </div>
</template>

<script>
import AlgorithmList from "../container/AlgorithmList";

export default {
  name: "Algorithms",
  components: {AlgorithmList}
}
</script>

<style>
@import '~@/assets/css/main.css';
@import '~@/assets/css/reset.css';
@import '~@/assets/css/content.css';
</style>

